import { FormPreviewRAM } from "@/contexts/fiscalizacao/relatorioAM/components/FormPreviewRAM/FormPreviewRAM";
import { ModalPlanoAcaoRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/components/ModalHistoricoPlanoAcaoRAM/ModalPlanoAcaoRelatorioAM";
import { useRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/hooks/useRelatorioAM";
import { PageLoader } from "@/shared/components/PageLoader/PageLoader";
import { useNetworkStatus } from "@/shared/hooks/useNetworkStatus";
import { ArrowLeftOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import {
  Button,
  Card,
  Col,
  Divider,
  Grid,
  Result,
  Row,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

export function VisualizacaoPlanoAcaoRAM() {
  const { isOnline } = useNetworkStatus();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint();
  const [isOpenModalHistorico, setIsOpenModalHistorico] = useState(false);
  const [itemIdSelecionado, setItemIdSelecionado] = useState<number | null>(
    null
  );
  const { getRelatorioAMByIdApi, canViewPlanoAcao } = useRelatorioAM();
  const { data: relatorio, isLoading: loadingRelatorio } = useQuery({
    queryKey: ["RAM_PLANO_ACAO_VISUALIZACAO", id],
    enabled: isOnline && !!id,
    queryFn: async () => {
      const response = await getRelatorioAMByIdApi(Number(id));
      return response;
    },
  });

  const handleBack = () => {
    navigate(-1);
  };

  const handleOpenHistoricoPlanoAcao = (itemId: number) => {
    setItemIdSelecionado(itemId);
    setIsOpenModalHistorico(true);
  };

  const handleCloseHistoricoPlanoAcao = () => {
    setIsOpenModalHistorico(false);
  };

  useEffect(() => {
    document.title =
      "Inspeção Mobile - Visualização Plano de Ação Relatórios de Auditoria e Monitoria";
  }, [relatorio]);

  if (!isOnline) {
    return <Result title="Sem conexão com a internet" status={"error"} />;
  }

  if (loadingRelatorio) {
    return <PageLoader />;
  }

  if (!relatorio) {
    return <Result title="Relatório não encontrado" status={"error"} />;
  }

  const userCanViewPlanoAcao = canViewPlanoAcao(
    relatorio.formulario?.classificacaoFormulario,
    relatorio.estabelecimento?.id
  );

  // if (!userCanViewPlanoAcao) {
  //   return <Navigate to={"/"} />;
  // }

  const itensNaoConformes =
    relatorio?.itens?.filter((item) => item.alternativa?.id === 2) || [];

  return (
    <>
      <Typography.Title
        level={screens.xs ? 3 : 4}
        style={{ textAlign: "center" }}
      >
        Plano de Ação do Relatorio de Auditoria e Monitoria
      </Typography.Title>

      <Divider />

      <FormPreviewRAM relatorio={relatorio} />

      <Divider orientation="left">
        <Typography.Title level={5}>Planos de Ação</Typography.Title>
      </Divider>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {itensNaoConformes.length === 0 && (
          <Col xs={24}>
            <Typography.Text type="secondary">
              Nenhum item não conforme encontrado neste relatório.
            </Typography.Text>
          </Col>
        )}
        {itensNaoConformes.map((item) => (
          <Col xs={24} key={item.uuid}>
            <Card
              title={
                <Typography.Text strong>{item.pergunta?.nome}</Typography.Text>
              }
              style={{ backgroundColor: "#f6f8fa" }}
              extra={
                <Button
                  type="primary"
                  icon={<UnorderedListOutlined />}
                  onClick={() => handleOpenHistoricoPlanoAcao(item.id!)}
                >
                  Histórico
                </Button>
              }
            >
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12}>
                  <Typography.Text type="secondary">
                    <strong>Seção:</strong> {item.secao?.nome}
                  </Typography.Text>
                </Col>
                <Col xs={24} sm={12}>
                  <Typography.Text type="secondary">
                    <strong>Data Resposta:</strong>{" "}
                    {item.dataResposta
                      ? dayjs(item.dataResposta).format("DD/MM/YYYY")
                      : "-"}
                  </Typography.Text>
                </Col>
                <Col xs={24} sm={12}>
                  <Typography.Text type="danger">
                    <strong>Alternativa: </strong>
                    {item.alternativa?.nome}
                  </Typography.Text>
                </Col>
                <Col xs={24} sm={12}>
                  <Typography.Text type="secondary">
                    <strong>Observação:</strong> {item.resposta || "-"}
                  </Typography.Text>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} justify={"center"}>
        <Col>
          <Button
            style={{ width: 200 }}
            onClick={handleBack}
            icon={<ArrowLeftOutlined />}
          >
            Voltar
          </Button>
        </Col>
      </Row>

      <ModalPlanoAcaoRelatorioAM
        open={isOpenModalHistorico}
        onClose={handleCloseHistoricoPlanoAcao}
        ramItemId={itemIdSelecionado!}
      />
    </>
  );
}
